// Copyright (c) 2021-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { Banner } from "../banner/Banner";
import './App.scss';

export function App() {
  return (
    <div className="App">
        <Banner />
    </div>
  );
}
